import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'

class Layer extends Component {

  constructor (props) {
    super(props)
    this.hidingAllowed = true
  }

  componentDidMount () {
    document.addEventListener('keydown', this.onKeydown, false)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.onKeydown, false)
  }

  onKeydown = (e) => {
    if (this.props.closeOnEsc && e.keyCode === 27) {
      this.onHideClick()
    }
  }

  onHideClick = () => {
    if (this.props.disallowHiding) {
      return
    }
    this.props.onHideClick()
  }

  render () {
    let className = 'Layer Layer-' + this.props.type + ' Layer-' + this.props.size
    if (this.props.show) {
      className += ' show'
    }
    if (this.props.background) {
      className += ' Layer-bg-' + this.props.background
    }
    return (
      <div className={className}
           id={this.props.id}>
        <div style={{ borderRadius: this.props.borderRadius }} className={'Layer-Content ' + this.props.className}>
          {this.props.children}
          {
            this.props.showCloseIcon && <div className="Layer-Close" onClick={this.onHideClick}>
              <i className="im im-x-mark"/>
            </div>
          }
        </div>
        <div className="Layer-Overlay" onClick={this.onHideClick}/>
      </div>
    )
  }
}

Layer.defaultProps = {
  showCloseIcon: true,
  closeOnEsc: false,
  borderRadius: 'none',
  disallowHiding: false,
}
Layer.propTypes = {
  id: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHideClick: PropTypes.func.isRequired,
  size: PropTypes.string,
  type: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  closeOnEsc: PropTypes.bool,
  className: PropTypes.any,
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  disallowHiding: PropTypes.bool,
}
export default Layer
